// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warm-lead-info-box {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #5616ea25;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 20px;
  line-height: 1.45;
  border-left: 5px solid #5616ea;
}

.warm-lead-info-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.warm-lead-info-box p {
  margin: 0;
}

.warm-lead-info-icon {
  font-size: 32px;
  color: #5616ea;
  flex-shrink: 0;
}

.warm-lead-warning-inner {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #fff9e1;
  border-left: 4px solid #ffc107;
  border-radius: 8px;
  padding: 8px 10px;
  margin-bottom: 12px;
}

.warm-lead-warning-inner p {
  margin: 0;
  color: #554002;
  font-size: 14px;
}

.warm-lead-warning-icon {
  font-size: 20px;
  color: #ffc107;
  flex-shrink: 0;
}

.warm-lead-email-receiver {
    max-width: 400px;
}

.add-email-button {
    background-color: transparent;
    border: none;
    outline: none;
    width: 50px;
    text-align: left;
    padding: 0;
    color: #5616ea;
    border-radius: 10px;
    font-size: 26px;
    transition: background-color 0.3s ease, transform 0.3s ease;
}

.add-email-button:hover {
    transform: translateY(-2px);
    cursor: pointer;
}

.add-email-button:disabled {
    color: #bbbbbb;
    transform: translateY(0px);
    cursor: not-allowed;
  }

.remove-email-button {
    background-color: transparent;
    border: none;
    outline: none;
    width: 50px;
    text-align: center;
    padding: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
    margin-top: 5px;
    color: grey;
    border-radius: 10px;
    font-size: 18px;
    transition: background-color 0.3s ease, transform 0.3s ease;
}

.remove-email-button:hover {
    transform: translateY(-2px);
    cursor: pointer;
}

.warm-lead-email-receiver {
    margin-bottom: 10px !important;
}

.parameter-item {
    margin-bottom: 15px;
    padding: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background-color: #fafafa;
    transition: background-color 0.2s ease;
}

.parameter-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.parameter-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.parameter-name {
    font-weight: 600 !important;
    color: #333;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.parameter-user-display-badge {
    font-weight: 400;
    font-size: 12px;
    color: #5616ea;
    background-color: #f3eaff;
    padding: 2px 8px;
    border-radius: 4px;
}

.parameter-description {
    color: #666;
    font-size: 13px;
    line-height: 1.4;
}

.parameter-name-input,
.parameter-description-input,
.parameter-user-display-input {
    width: 100%;
}

.parameter-name-input .MuiOutlinedInput-input,
.parameter-user-display-input .MuiOutlinedInput-input {
    padding: 12px 14px;
}

.parameter-description-input .MuiOutlinedInput-root {
    padding: 0;
}

.parameter-description-input textarea {
    padding: 12px 14px !important;
}

.parameter-actions {
    display: flex;
    gap: 8px;
    align-items: flex-start;
}

.edit-parameter-button,
.delete-parameter-button {
    background-color: transparent;
    border: none;
    outline: none;
    width: 36px;
    height: 36px;
    text-align: center;
    padding: 8px;
    color: #5616ea;
    border-radius: 6px;
    font-size: 16px;
    transition: background-color 0.3s ease, transform 0.2s ease, color 0.2s ease;
    cursor: pointer;
}

.edit-parameter-button:hover {
    background-color: #5616ea15;
    color: #5616ea;
    transform: translateY(-2px);
}

.delete-parameter-button:hover {
    background-color: #5616ea15;
    color: #5616ea;
    transform: translateY(-2px);
}

.edit-parameter-button:disabled,
.delete-parameter-button:disabled {
    color: #bbbbbb;
    transform: translateY(0px);
    cursor: not-allowed;
    background-color: transparent;
}

.add-parameter-button-icon {
    background-color: transparent;
    border: none;
    outline: none;
    width: 50px;
    text-align: left;
    padding: 0;
    color: #5616ea;
    border-radius: 10px;
    font-size: 26px;
    transition: background-color 0.3s ease, transform 0.3s ease;
}

.add-parameter-button-icon:hover {
    transform: translateY(-2px);
    cursor: pointer;
}

.add-parameter-button-icon:disabled {
    color: #bbbbbb;
    transform: translateY(0px);
    cursor: not-allowed;
}

.warm-lead-new-badge {
    background-color: #5616ea;
    color: #fff;
    border-radius: 8px;
    padding: 5px;
    padding-bottom: 4px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    box-shadow: 0 2px 6px rgba(94, 27, 255, 0.4);
    white-space: nowrap;
    margin-left: -2px;
    position: relative;
    top: -20px;
}

.warm-lead-new-badge-inline {
    background-color: #5616ea;
    color: #fff;
    border-radius: 8px;
    padding: 5px;
    padding-bottom: 4px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    box-shadow: 0 2px 6px rgba(94, 27, 255, 0.4);
    white-space: nowrap;
    margin-left: 8px;
    position: relative;
    top: -10px;
}

/* Contact Collection Mode Section */
.required-fields-section {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 14px;
    border: 1px solid #e0e0e0;
    margin-top: 12px;
}

.required-fields-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.required-field-item {
    display: flex;
    align-items: center !important;
    margin-left: 0 !important;
    padding: 8px 12px;
    background-color: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    transition: background-color 0.2s ease, border-color 0.2s ease;
    margin-right: 0px !important;
}

.required-field-item:hover {
    background-color: #fafafa;
    border-color: #d0d0d0;
}

.required-field-item .MuiCheckbox-root {
    padding: 4px;
    margin-right: 8px;
}

.required-fields-info-box {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: #e8f4fd;
    border-radius: 6px;
    padding: 10px 12px;
    margin-bottom: 12px;
}

.required-fields-info-icon {
    font-size: 14px;
    color: #1976d2;
    flex-shrink: 0;
}

/* Multilingual pre-chat form (18.10.2026): each field's label per language */
.prechat-translate-button {
    background-color: transparent;
    border: none;
    outline: none;
    width: 36px;
    height: 36px;
    padding: 8px;
    color: #5616ea;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.prechat-translate-button:hover,
.prechat-translate-button[aria-expanded="true"] {
    background-color: #5616ea15;
}

/* one card per pre-chat field (Design tab); its translations fold open inside it */
.prechat-field {
    background-color: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    transition: background-color 0.2s ease, border-color 0.2s ease;
}

.prechat-field:hover,
.prechat-field.is-open {
    border-color: #d0d0d0;
}

.prechat-field-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    min-height: 36px;
}

.prechat-field-row .MuiCheckbox-root {
    padding: 4px;
    margin-right: 8px;
}

.prechat-field-pending {
    display: flex;
    align-items: center;
    gap: 14px;
    flex: 1 1;
    color: #888;
}

.prechat-field-spinner {
    width: 18px;
    margin: 0 6px 0 7px;
    color: #5616ea;
}

/* smooth open/close: the row track grows from 0 to the content height */
.prechat-field-fold {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.28s ease;
}

.prechat-field.is-open .prechat-field-fold {
    grid-template-rows: 1fr;
}

.prechat-field-fold-inner {
    min-height: 0;
    overflow: hidden;
}

.prechat-translations {
    margin: 0 12px 12px 12px;
    padding-top: 12px;
    border-top: 1px solid #f0edf7;
}

.prechat-translations-hint {
    margin: 0 0 10px 0;
    font-size: 13px;
    color: #666;
}

.prechat-translations-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 8px 12px;
}

.prechat-translation {
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-size: 12px;
    color: #555;
}

.prechat-translation input {
    padding: 7px 9px;
    font-size: 14px;
    border: 1px solid #dcd7ea;
    border-radius: 6px;
    background: #fff;
}

.prechat-translation input:focus {
    outline: none;
    border-color: #5616ea;
}
`, "",{"version":3,"sources":["webpack://./src/components/warmLeadConfig.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,mBAAmB;EACrB;;AAEF;IACI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,2BAA2B;IAC3B,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;;IAEI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,4EAA4E;IAC5E,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,2BAA2B;AAC/B;;AAEA;;IAEI,cAAc;IACd,0BAA0B;IAC1B,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,2DAA2D;AAC/D;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,4CAA4C;IAC5C,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,4CAA4C;IAC5C,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA,oCAAoC;AACpC;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,8DAA8D;IAC9D,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,2DAA2D;AAC/D;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA,mFAAmF;AACnF;IACI,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,8DAA8D;AAClE;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,WAAW;AACf;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;AAClB;;AAEA,wEAAwE;AACxE;IACI,aAAa;IACb,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB","sourcesContent":[".warm-lead-info-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  background-color: #5616ea25;\r\n  border-radius: 10px;\r\n  padding: 14px;\r\n  margin-bottom: 20px;\r\n  line-height: 1.45;\r\n  border-left: 5px solid #5616ea;\r\n}\r\n\r\n.warm-lead-info-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.warm-lead-info-box p {\r\n  margin: 0;\r\n}\r\n\r\n.warm-lead-info-icon {\r\n  font-size: 32px;\r\n  color: #5616ea;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.warm-lead-warning-inner {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  background-color: #fff9e1;\r\n  border-left: 4px solid #ffc107;\r\n  border-radius: 8px;\r\n  padding: 8px 10px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.warm-lead-warning-inner p {\r\n  margin: 0;\r\n  color: #554002;\r\n  font-size: 14px;\r\n}\r\n\r\n.warm-lead-warning-icon {\r\n  font-size: 20px;\r\n  color: #ffc107;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.warm-lead-email-receiver {\r\n    max-width: 400px;\r\n}\r\n\r\n.add-email-button {\r\n    background-color: transparent;\r\n    border: none;\r\n    outline: none;\r\n    width: 50px;\r\n    text-align: left;\r\n    padding: 0;\r\n    color: #5616ea;\r\n    border-radius: 10px;\r\n    font-size: 26px;\r\n    transition: background-color 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.add-email-button:hover {\r\n    transform: translateY(-2px);\r\n    cursor: pointer;\r\n}\r\n\r\n.add-email-button:disabled {\r\n    color: #bbbbbb;\r\n    transform: translateY(0px);\r\n    cursor: not-allowed;\r\n  }\r\n\r\n.remove-email-button {\r\n    background-color: transparent;\r\n    border: none;\r\n    outline: none;\r\n    width: 50px;\r\n    text-align: center;\r\n    padding: 10px;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n    margin-top: 5px;\r\n    color: grey;\r\n    border-radius: 10px;\r\n    font-size: 18px;\r\n    transition: background-color 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.remove-email-button:hover {\r\n    transform: translateY(-2px);\r\n    cursor: pointer;\r\n}\r\n\r\n.warm-lead-email-receiver {\r\n    margin-bottom: 10px !important;\r\n}\r\n\r\n.parameter-item {\r\n    margin-bottom: 15px;\r\n    padding: 12px;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    background-color: #fafafa;\r\n    transition: background-color 0.2s ease;\r\n}\r\n\r\n.parameter-row {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n}\r\n\r\n.parameter-content {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n}\r\n\r\n.parameter-name {\r\n    font-weight: 600 !important;\r\n    color: #333;\r\n    font-size: 14px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.parameter-user-display-badge {\r\n    font-weight: 400;\r\n    font-size: 12px;\r\n    color: #5616ea;\r\n    background-color: #f3eaff;\r\n    padding: 2px 8px;\r\n    border-radius: 4px;\r\n}\r\n\r\n.parameter-description {\r\n    color: #666;\r\n    font-size: 13px;\r\n    line-height: 1.4;\r\n}\r\n\r\n.parameter-name-input,\r\n.parameter-description-input,\r\n.parameter-user-display-input {\r\n    width: 100%;\r\n}\r\n\r\n.parameter-name-input .MuiOutlinedInput-input,\r\n.parameter-user-display-input .MuiOutlinedInput-input {\r\n    padding: 12px 14px;\r\n}\r\n\r\n.parameter-description-input .MuiOutlinedInput-root {\r\n    padding: 0;\r\n}\r\n\r\n.parameter-description-input textarea {\r\n    padding: 12px 14px !important;\r\n}\r\n\r\n.parameter-actions {\r\n    display: flex;\r\n    gap: 8px;\r\n    align-items: flex-start;\r\n}\r\n\r\n.edit-parameter-button,\r\n.delete-parameter-button {\r\n    background-color: transparent;\r\n    border: none;\r\n    outline: none;\r\n    width: 36px;\r\n    height: 36px;\r\n    text-align: center;\r\n    padding: 8px;\r\n    color: #5616ea;\r\n    border-radius: 6px;\r\n    font-size: 16px;\r\n    transition: background-color 0.3s ease, transform 0.2s ease, color 0.2s ease;\r\n    cursor: pointer;\r\n}\r\n\r\n.edit-parameter-button:hover {\r\n    background-color: #5616ea15;\r\n    color: #5616ea;\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.delete-parameter-button:hover {\r\n    background-color: #5616ea15;\r\n    color: #5616ea;\r\n    transform: translateY(-2px);\r\n}\r\n\r\n.edit-parameter-button:disabled,\r\n.delete-parameter-button:disabled {\r\n    color: #bbbbbb;\r\n    transform: translateY(0px);\r\n    cursor: not-allowed;\r\n    background-color: transparent;\r\n}\r\n\r\n.add-parameter-button-icon {\r\n    background-color: transparent;\r\n    border: none;\r\n    outline: none;\r\n    width: 50px;\r\n    text-align: left;\r\n    padding: 0;\r\n    color: #5616ea;\r\n    border-radius: 10px;\r\n    font-size: 26px;\r\n    transition: background-color 0.3s ease, transform 0.3s ease;\r\n}\r\n\r\n.add-parameter-button-icon:hover {\r\n    transform: translateY(-2px);\r\n    cursor: pointer;\r\n}\r\n\r\n.add-parameter-button-icon:disabled {\r\n    color: #bbbbbb;\r\n    transform: translateY(0px);\r\n    cursor: not-allowed;\r\n}\r\n\r\n.warm-lead-new-badge {\r\n    background-color: #5616ea;\r\n    color: #fff;\r\n    border-radius: 8px;\r\n    padding: 5px;\r\n    padding-bottom: 4px;\r\n    font-size: 10px;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.03em;\r\n    box-shadow: 0 2px 6px rgba(94, 27, 255, 0.4);\r\n    white-space: nowrap;\r\n    margin-left: -2px;\r\n    position: relative;\r\n    top: -20px;\r\n}\r\n\r\n.warm-lead-new-badge-inline {\r\n    background-color: #5616ea;\r\n    color: #fff;\r\n    border-radius: 8px;\r\n    padding: 5px;\r\n    padding-bottom: 4px;\r\n    font-size: 10px;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.03em;\r\n    box-shadow: 0 2px 6px rgba(94, 27, 255, 0.4);\r\n    white-space: nowrap;\r\n    margin-left: 8px;\r\n    position: relative;\r\n    top: -10px;\r\n}\r\n\r\n/* Contact Collection Mode Section */\r\n.required-fields-section {\r\n    background-color: #f8f9fa;\r\n    border-radius: 8px;\r\n    padding: 14px;\r\n    border: 1px solid #e0e0e0;\r\n    margin-top: 12px;\r\n}\r\n\r\n.required-fields-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n\r\n.required-field-item {\r\n    display: flex;\r\n    align-items: center !important;\r\n    margin-left: 0 !important;\r\n    padding: 8px 12px;\r\n    background-color: #fff;\r\n    border: 1px solid #e8e8e8;\r\n    border-radius: 6px;\r\n    transition: background-color 0.2s ease, border-color 0.2s ease;\r\n    margin-right: 0px !important;\r\n}\r\n\r\n.required-field-item:hover {\r\n    background-color: #fafafa;\r\n    border-color: #d0d0d0;\r\n}\r\n\r\n.required-field-item .MuiCheckbox-root {\r\n    padding: 4px;\r\n    margin-right: 8px;\r\n}\r\n\r\n.required-fields-info-box {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    background-color: #e8f4fd;\r\n    border-radius: 6px;\r\n    padding: 10px 12px;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.required-fields-info-icon {\r\n    font-size: 14px;\r\n    color: #1976d2;\r\n    flex-shrink: 0;\r\n}\r\n\r\n/* Multilingual pre-chat form (18.10.2026): each field's label per language */\r\n.prechat-translate-button {\r\n    background-color: transparent;\r\n    border: none;\r\n    outline: none;\r\n    width: 36px;\r\n    height: 36px;\r\n    padding: 8px;\r\n    color: #5616ea;\r\n    border-radius: 6px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease, transform 0.2s ease;\r\n}\r\n\r\n.prechat-translate-button:hover,\r\n.prechat-translate-button[aria-expanded=\"true\"] {\r\n    background-color: #5616ea15;\r\n}\r\n\r\n/* one card per pre-chat field (Design tab); its translations fold open inside it */\r\n.prechat-field {\r\n    background-color: #fff;\r\n    border: 1px solid #e8e8e8;\r\n    border-radius: 6px;\r\n    transition: background-color 0.2s ease, border-color 0.2s ease;\r\n}\r\n\r\n.prechat-field:hover,\r\n.prechat-field.is-open {\r\n    border-color: #d0d0d0;\r\n}\r\n\r\n.prechat-field-row {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 8px 12px;\r\n    min-height: 36px;\r\n}\r\n\r\n.prechat-field-row .MuiCheckbox-root {\r\n    padding: 4px;\r\n    margin-right: 8px;\r\n}\r\n\r\n.prechat-field-pending {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 14px;\r\n    flex: 1;\r\n    color: #888;\r\n}\r\n\r\n.prechat-field-spinner {\r\n    width: 18px;\r\n    margin: 0 6px 0 7px;\r\n    color: #5616ea;\r\n}\r\n\r\n/* smooth open/close: the row track grows from 0 to the content height */\r\n.prechat-field-fold {\r\n    display: grid;\r\n    grid-template-rows: 0fr;\r\n    transition: grid-template-rows 0.28s ease;\r\n}\r\n\r\n.prechat-field.is-open .prechat-field-fold {\r\n    grid-template-rows: 1fr;\r\n}\r\n\r\n.prechat-field-fold-inner {\r\n    min-height: 0;\r\n    overflow: hidden;\r\n}\r\n\r\n.prechat-translations {\r\n    margin: 0 12px 12px 12px;\r\n    padding-top: 12px;\r\n    border-top: 1px solid #f0edf7;\r\n}\r\n\r\n.prechat-translations-hint {\r\n    margin: 0 0 10px 0;\r\n    font-size: 13px;\r\n    color: #666;\r\n}\r\n\r\n.prechat-translations-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\r\n    gap: 8px 12px;\r\n}\r\n\r\n.prechat-translation {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 3px;\r\n    font-size: 12px;\r\n    color: #555;\r\n}\r\n\r\n.prechat-translation input {\r\n    padding: 7px 9px;\r\n    font-size: 14px;\r\n    border: 1px solid #dcd7ea;\r\n    border-radius: 6px;\r\n    background: #fff;\r\n}\r\n\r\n.prechat-translation input:focus {\r\n    outline: none;\r\n    border-color: #5616ea;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
